export const ensureTwoDecimalPlaces = (value: number): string => value.toFixed(2);
